module.exports = __webpack_public_path__ + "img/person-fail.cd619f67.png";